import * as AlertDialog from '@givebutter/primitives/alert-dialog';

interface BidderNumberConfirmationDialogProps extends AlertDialog.AlertDialogRootProps {
    onConfirm: Function;
}
const BidderNumberConfirmationDialog = (props: BidderNumberConfirmationDialogProps) => {
    const { onConfirm, ...rest } = props;

    return (
        <AlertDialog.Root type="warning" {...rest}>
            <AlertDialog.Portal>
                <AlertDialog.Overlay />
                <AlertDialog.Content className="max-w-sm p-6">
                    <AlertDialog.Header>
                        <AlertDialog.Icon />
                        <AlertDialog.Close onClick={() => onConfirm(false)} />
                    </AlertDialog.Header>
                    <AlertDialog.Body>
                        <AlertDialog.Title>Your auction is currently live</AlertDialog.Title>
                        <AlertDialog.Description>
                            Changes to the the starting bidder number will only apply to new
                            bidders.
                        </AlertDialog.Description>
                    </AlertDialog.Body>
                    <AlertDialog.Footer>
                        <AlertDialog.Cancel onClick={() => onConfirm(false)}>
                            Cancel
                        </AlertDialog.Cancel>
                        <AlertDialog.Action onClick={() => onConfirm(true)}>
                            Continue
                        </AlertDialog.Action>
                    </AlertDialog.Footer>
                </AlertDialog.Content>
            </AlertDialog.Portal>
        </AlertDialog.Root>
    );
};

const BidderNumberConfirmationDialogTrigger = AlertDialog.Trigger;

const Root = BidderNumberConfirmationDialog;
const Trigger = BidderNumberConfirmationDialogTrigger;

export {
    Root,
    Trigger,
    //
    BidderNumberConfirmationDialog,
    BidderNumberConfirmationDialogTrigger,
};
